import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/homepage/styles/home2.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next/dist/client/link.js");
